export enum TimeOffSettingsTabs {
  settings = "settings",
  policyReport = "policy_report",
}
